import React from 'react';
import { useNavigate } from 'react-router-dom';
import Titulo from '@components/Titulo';
import Boton from '@components/Boton';
import { colors } from '@styles/colors';

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorStyle } from '@styles/cajaContenedor';

function NotFound() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div style={cajaPrincipalStyle}>
      <div style={cajaContenedorStyle}>
        <Titulo 
          titulo="404 - Página no encontrada" 
          subtitulo="La página que buscas no existe"
          color={colors.notFoundRed}
        />
        
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '3vh',
          marginTop: '5vh',
          textAlign: 'center'
        }}>
          <div style={{
            fontSize: '8vh',
            color: colors.notFoundRed,
            fontWeight: 'bold',
            marginBottom: '2vh'
          }}>
            404
          </div>
          
          <div style={{
            fontSize: '2.5vh',
            color: colors.gray600,
            marginBottom: '3vh',
            maxWidth: '50vh',
            lineHeight: '1.5'
          }}>
            Lo sentimos, la página que estás buscando no existe o ha sido movida.
          </div>
          
          <div style={{
            display: 'flex',
            gap: '2vh',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            <Boton 
              texto="Ir al inicio" 
              onClick={handleGoHome}
              color={colors.primary}
            />
            <Boton 
              texto="Volver atrás" 
              onClick={handleGoBack}
              color={colors.secondaryButton}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotFound;